(function() {
        const MAIN_FADE_DELAY = 0;
        const VISIT_TTL_DAYS = 7;
        const STORAGE_KEY = 'planet_first_visit';

        function isFirstVisit() {
          try {
            const item = localStorage.getItem(STORAGE_KEY);
            if (!item) return true;
            const data = JSON.parse(item);
            const now = Date.now();
            const ttl = VISIT_TTL_DAYS * 24 * 60 * 60 * 1000;
            return !data.timestamp || (now - data.timestamp) > ttl;
          } catch (e) {
            return true;
          }
        }

        function markVisited() {
          try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({ timestamp: Date.now() }));
          } catch (e) {}
        }

        function showMainImmediately(mainEl) {
          mainEl.classList.remove('opacity-0');
          mainEl.classList.add('opacity-100');
        }

        function initIntro() {
          const main = document.getElementById('MainContent');
          if (!main) return;

          // s'assurer qu’on a les classes tailwind d’opacité
          main.classList.add('transition-opacity', 'duration-0');

          if (!isFirstVisit()) {
            showMainImmediately(main);
            return;
          }

          // première visite récente : cacher le main pendant un moment
          markVisited();

          // s’il est déjà visible pour une raison quelconque, on le recache
          main.classList.add('opacity-0');
          main.classList.remove('opacity-100');

          setTimeout(() => {
            showMainImmediately(main);
          }, MAIN_FADE_DELAY);
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initIntro);
        } else {
          initIntro();
        }

        window.addEventListener('shopify:section:load', initIntro);
      })();